// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"c38dff52","398":"d7f7fc63","958":"bc59db53"}[chunkId] + ".chunk.css";
};